import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import SignIn from '../pages/auth/SignIn';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import NotFound from '../pages/404';
import PropTypes from 'prop-types';
//import Home from '../pages/Home';
import Inspection from '../pages/Inspection';
import Report from '../pages/Report';
import Companies from '../pages/Companies';
import Profile from '../pages/Profile';
import Debug from '../pages/Debug';
import AuthRoute from './AuthRoute';
import { connect } from 'react-redux';
import { setLoading } from '../actions/loading';
import { initAuthFromExistingToken } from '../actions/auth';
import { updateLocaleRequest } from '../actions/profile';
import GuestRoute from './GuestRoute';
import {ToastContainer} from "react-toastify";
import { enableMapSet } from 'immer';

import 'react-toastify/dist/ReactToastify.min.css';
import '../../css/tailwind.css';

enableMapSet();

const propTypes = {
  setLoading: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initAuthFromExistingToken: PropTypes.func.isRequired,
  updateLocaleRequest: PropTypes.func.isRequired,
};

class App extends Component {
  componentDidMount () {
    this.props.initAuthFromExistingToken((user) => {
      if(user && user.language != window.App.locale){
        // Change language if user is logged in and current locale is not matching users locale
        this.props.updateLocaleRequest({user: user, language: user.language})
          .then(() => this.props.setLoading(false));
      } else {
        this.props.setLoading(false)  
      }
    });
  }

  render () {
    document.body.classList.remove(... document.body.classList);
    if (this.props.loading) {
      document.body.classList.add('bg-green-gradient-2');
      return (
        <div className="centered-container">
          <img src={window.App.baseUrl + "assets/app/img/logo.png"} alt="BatterySpray" className="img-fluid mw-sm-400" />
        </div>
      );
    }

    return (
      <Router basename={window.App.baseUrl}>
        <ToastContainer stacked hideProgressBar position={'bottom-right'} theme={'colored'}/>
        <Switch>
          <GuestRoute exact path="/" component={SignIn} />
          <GuestRoute path="/forgot-password" component={ForgotPassword} />
          <GuestRoute path="/password/reset/:token" component={ResetPassword} />
          <AuthRoute path="/home" component={Inspection} />
          <AuthRoute path="/report" component={Report} />
          <AuthRoute path="/companies" component={Companies} />
          <AuthRoute path="/profile" component={Profile} />
          <AuthRoute path="/debug" component={Debug} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

App.propTypes = propTypes;

const mapDispatchToProps = {
  setLoading,
  initAuthFromExistingToken,
  updateLocaleRequest
};

const mapStateToProps = ({ loading }) => ({ loading });

export default connect(mapStateToProps, mapDispatchToProps)(App);
